import { useEffect, useRef } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useI18n } from '@/i18n/LanguageContext';

/**
 * Applies the language saved on the user's profile the first time a session is
 * restored or a user logs in, so a Spanish-speaking user always lands in
 * Spanish on any device. Manual switching afterwards still wins for the
 * remainder of the session (and is persisted back to the profile by the
 * language toggle).
 */
const LanguageSync = () => {
  const { profile, user } = useAuth();
  const { lang, setLang } = useI18n();
  const appliedFor = useRef<string | null>(null);

  useEffect(() => {
    if (!user || !profile) return;
    if (appliedFor.current === user.id) return;
    appliedFor.current = user.id;
    const preferred = profile.preferred_language === 'es' ? 'es' : 'en';
    if (preferred !== lang) setLang(preferred);
  }, [user, profile, lang, setLang]);

  return null;
};

export default LanguageSync;
